/**
 * Fix for duplicate custom element registration
 * Some libraries (like TipTap) may try to register custom elements multiple times
 * This prevents the error by checking if the element is already defined
 */

const originalDefine = customElements.define;

customElements.define = function(name: string, constructor: any, options?: any) {
  if (customElements.get(name)) {
    console.warn(`Custom element '${name}' already defined, skipping re-registration`);
    return;
  }
  
  return originalDefine.call(this, name, constructor, options);
};

export {};